export default "__VITE_ASSET__1654a6da__"